import { render } from "./TMultiSelectCategory.vue?vue&type=template&id=3ef4b7f6&scoped=true"
import script from "./TMultiSelectCategory.vue?vue&type=script&lang=js"
export * from "./TMultiSelectCategory.vue?vue&type=script&lang=js"

import "./TMultiSelectCategory.vue?vue&type=style&index=0&id=3ef4b7f6&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef4b7f6"]])

export default __exports__